<template>
  <footer>
    <div class="container">
      <div class="footer-inner">
        <div class="footer-left">
          <div class="footer-logo">
            <img src="@/assets/img/logo-white.svg" height="30px" alt="" />
          </div>
          <div class="footer-menu">
            <ul>
              <li
                class="footer-link"
                v-router-link="{ path: '/privacypolicy' }"
              >
                Privacy Policy
              </li>
              <li class="footer-link" v-router-link="{ path: '/termsofuse' }">
                Terms of Use
              </li>
            </ul>
          </div>
          <p class="copyright">© 2022 CTO Circle. All Rights Reserved.</p>
        </div>
        <div class="footer-right">
          <div class="address">
            <img src="@/assets/img/cs-icons-marker.svg" />
            <span>#17/18 Centennial Tower,<br />Singapore 039190</span>
          </div>
          <ul class="social">
            <li>
              <a href="https://www.meetup.com/pro/ctocircle" target="_blank"
                ><img src="@/assets/img/icons8-meetup.svg" alt="" class="meetup"
              /></a>
            </li>
            <li>
              <a href="https://www.facebook.com/ctocircle" target="_blank"
                ><img src="@/assets/img/cs-icons-facebook-filled.svg" alt=""
              /></a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/company/ctocircle"
                target="_blank"
                ><img src="@/assets/img/cs-icons-linkedin-filled.svg" alt=""
              /></a>
            </li>
            <li>
              <a href="https://www.twitter.com/theCTOCircle" target="_blank"
                ><img src="@/assets/img/cs-icons-twitter-filled.svg" alt=""
              /></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'app-footer',
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
};
</script>

<style lang="scss" scoped>
footer {
  background: var(--cs-primary-base);
  padding: 50px 0;

  .footer-inner {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .footer-logo {
    margin-bottom: 25px;
  }

  .footer-menu ul {
    padding: 0;
    margin: 0 0 5px;
    display: flex;
    flex-direction: row;
  }

  .footer-menu ul li {
    list-style: none;
    margin-left: 10px;
  }

  .footer-menu ul li:before {
    content: '·';
    color: #f5f7f6;
    margin-right: 10px;
  }

  .footer-menu ul li:first-child {
    margin: 0;
  }

  .footer-menu ul li:first-child:before {
    display: none;
  }

  .footer-menu ul li a {
    color: #fff;
    text-decoration: none;
    font-weight: bold;
  }

  p.copyright {
    font-size: 16px;
    line-height: 24px;
    margin: 0;
    color: #f5f7f6;
  }

  .footer-right {
    text-align: right;
  }

  .address span {
    color: #f5f7f6;
    margin-left: 15px;
  }

  ul.social {
    margin: 25px 0 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    gap: 20px;
  }

  ul.social li {
    list-style: none;
  }

  ul.social li img {
    height: 24px;
  }

  ul.social li .meetup {
    height: 32px;
  }
  .footer-link {
    color: white;
    cursor: pointer;
    font-weight: 600;
  }
  @media (max-width: 575px) {
    .footer-inner {
      flex-direction: column;
      align-items: center;
    }
    .footer-right {
      text-align: center;
      margin-top: 20px;
    }
    ul.social {
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
